<template>
  <div id="map"></div>
</template>

<script>
const GoogleMapsLoader = require("google-maps");
const MarkerClusterer = require("node-js-marker-clusterer");
export default {
  components: {},
  data() {
    return {
      locations: [],
      cities: []
    };
  },
  methods: {
    initMap: function(data) {
      GoogleMapsLoader.KEY = "AIzaSyBHuFnXcvRwI6SNmxF-1MsM36xQH0zoxbE";
      var that = this;
      GoogleMapsLoader.load(function(google) {
        var map = new google.maps.Map(document.getElementById("map"), {
          zoom: 9,
          center: { lat: 13.7561783, lng: 100.14983 }
        });
        that.setMarkers(data, map);
      });
    },
    setMarkers: function(data, map) {
      var that = this;
      if (
        data &&
        data.latitude &&
        data.latitude.buckets.length > 0
      ) {
        let infowindow = new google.maps.InfoWindow();
        for (let i = 0; i < data.city.buckets.length; i++) {
          let city = data.city.buckets[i].key || "";
          let latitude = data.latitude.buckets[i].key || 0.0;
          let longitude = data.longitude.buckets[i].key || 0.0;
          let marker = new google.maps.Marker({
            position: { lat: latitude, lng: longitude },
            map: map,
            title: city
          });
          google.maps.event.addListener(
            marker,
            "click",
            (function(marker, i, city) {
              return function() {
                infowindow.setContent(city);
                infowindow.open(map, marker);
              };
            })(marker, i, city)
          );
        }
      }
      for (let i = 0; i < data.city.buckets.length; i++) {
        let count = data.city.buckets[i].doc_count;
        for (let j = 0; j < count; j++) {
          let location = {};
          location.lat = data.latitude.buckets[i].key;
          location.lng = data.longitude.buckets[i].key;
          let city = data.city.buckets[i].key;
          that.locations.push(location);
          that.cities.push(city);
        }
      }
      let markers = that.locations.map((location, i) => {
        return new google.maps.Marker({
          position: location,
          label: that.cities[i]
        });
      });
      let markerCluster = new MarkerClusterer(map, markers, {
        imagePath:
          "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"
      });
    }
  }
};
</script>
